import { ActionStatusContainer, Content } from 'components/ActionStatus/styles'
import { CheckIcon } from 'components/Icons/CheckIcon'
import { AlertIcon } from 'components/Icons/AlertIcon'

interface ActionStatusProps {
  status: number
  text: string
}

const ActionStatus = ({ status, text }: ActionStatusProps) => {
  return (
    <ActionStatusContainer>
      <Content className={status === 1 ? 'bg-active' : 'bg-errorText'}>
        {status === 1 ? <CheckIcon /> : <AlertIcon />}
        {text}
      </Content>
    </ActionStatusContainer>
  )
}

export default ActionStatus
